import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";


import { PlusIcon } from "@heroicons/react/20/solid";
import noEventImage from "../../../assets/noEventImage.svg";
import { TwButton, TwConfirmDialog, TwContainer, TwDropzone, TwFormHelperText, TwInputGroup, TwMainLayout, TwPopover, TwTabContainer, TwTextEditer } from "../../../components/tailwind";
import TwDrawer from "../../../components/tailwind/TwDrawer";
import { useLocalStorage } from "../../../hooks";
import { useToast } from "../../../provider/ToastProvider";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";
import { loadingState, setActionLoading, setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings, getUrlForClasses } from "../../../utils/confighelpers";
import ConsumersProductTile from "./ConsumersProductTile";
import { EyeIcon } from "@heroicons/react/20/solid";
import delete_svg from "../../../assets/delete_svg.svg";
import edit_svg from "../../../assets/edit_svg.svg";
import { billingPeriod } from "../../../utils/constants";
import { userState } from "../../../redux/reducers/userReducer";
import { DEFAULT_TENANT, useTenant } from "../../../provider/TenantProvider";

export default function UAConsumersProductList({ navigation, profileFor, title }) {

  const { tenant, tenantData, tenantLoading } = useTenant();
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const [productsList, setProductsList] = React.useState([]);
  const productData = {
    topicName: "",
    topicSummary: "",
    topicCategory: "",
    topicImage: [],
    topicContent: "",
    status: "draft"
  };

  const [showProducts, setShowProducts] = React.useState({ open: false, productType: "classpass", isEdit: false, data: productData });
  const [listPageNumber, setListPageNumber] = React.useState(1);
  const [showViewMore, setShowViewMore] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      console.log("tenant", tenant);
      console.log("tenantData", tenantData);
      if (tenant != DEFAULT_TENANT && tenantData.businessId && tenantData.businessId !== "") {
        await getProductsList(listPageNumber);
      }
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken, dashboardReduxState.updateSessionComp, listPageNumber, tenantData]);


  const handleSessionClick = async (id) => {
    navigate(`/products/detail?id=${id}`);
  };

  const getProductsList = async (page = 1) => {
    setShowViewMore(false);
    let mgProducts = [];
    const config = {
      method: "get",
      url: `${getUrlForClasses("")}products/list?page=${page}&limit=10&businessId=${tenantData.businessId}`,
    };
    dispatch(setGlobalLoading(true));
    const productRequest = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (productRequest.status === 200) {
      // console.log("productRequest.data.data", productRequest.data.data.data);

      if (productRequest.data.data.data.length) {
        if (productRequest.data.data.total > 10) {
          setShowViewMore(true);
        }
        for (let item of productRequest.data.data.data) {
          // mgProducts.push({
          //   label: item.topicName,
          //   id: item._id,
          //   data: item
          // });
          // if (item.productFields.classList) { delete item.productFields.classList }
          mgProducts.push(item);
          if (listPageNumber > 1) {
            setProductsList([...productsList, ...mgProducts]);
          } else {
            setProductsList(mgProducts);
          }
        }
      }
    }
  };

  const renderProducts = (dataList, productType = "classpass") => {
    let data = dataList.filter((f) => f.availableForSale && f?.productType == productType);
    // setIsNoClassAvailable(true)
    return data.length > 0 ? (
      data.map((item, idx) => {
        return (
          <ConsumersProductTile
            data={item}
            key={idx}
            bookProduct={(data) => {
              bookProduct(data);
            }}
            reloadData={async () => {
              await getProductsList(listPageNumber);
            }}
          />
        );
      })
    ) : (
      <li className={"text-black text-center py-2"}>No news feeds are available</li>
    );
  };



  const bookProduct = async (productId) => {

    console.log("userToken", userToken);
    if (!userToken) {
      // navigation("/?returnurl=" + encodeURIComponent(location?.pathname));
      navigation("/members/signup?returnurl=" + encodeURIComponent("/members/webshop"));
      return;
    }
    let body = {
      productId: productId,
      username: userReduxState.userData?.username,
      fullName: userReduxState.userData?.fullName,
      email: userReduxState.userData?.email || '',
      success_url: `${window.location.origin}/checkout/success`,
      cancel_url: `${window.location.origin}/checkout/cancel`,
    };
    const config = {
      method: "post",
      url: `${getUrlForBookings("")}createCheckoutSessionsOfUserPurchase`,
      data: body,
    };

    console.log(config);
    // return;

    dispatch(setGlobalLoading(true));
    const productRequest = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (productRequest.status === 200) {
      if (productRequest.data.statusCode === 403) {
        addNotificationDialog({
          dialogType: "error",
          dialogTitle: "Error",
          dialogMessage: productRequest.data.message,
          dialogBtnTitle: "Ok",
          dialogBackdropClick: async () => { },
          dialogBtnClick: async () => { }
        })
      } else if (productRequest.data.statusCode === 200) {
        let responseData = productRequest.data.data;
        if (responseData?.checkoutSession?.url) {
          // window.location.href = responseData.url;
          window.open(responseData.checkoutSession.url, '_blank');
        } else {
          addNotificationDialog({
            dialogType: "error",
            dialogTitle: "Error",
            dialogMessage: "Something is wrong please try again",
            dialogBtnTitle: "Ok",
            dialogBackdropClick: async () => { },
            dialogBtnClick: async () => { }
          })
        }
      }
    }
  };


  return (
    <TwMainLayout
      userType={"student"}
      fullScreen={true}
      checkSession={false}
      children={
        <div className="flex flex-col gap-5">
          <div className="bg-black text-white text-lg text-center p-4">{tenantData?.businessName || ""}</div>
          <TwContainer className="">
            <div className="text-center p-4">
              <div className="text-lg font-bold">
                {tenantData?.businessName || ""} online shop
              </div>
              <div className="text-gray-400">
                {tenantData?.business_details?.business_detail?.about || ""}
              </div>
            </div>
            {productsList.length ? (<div
              className={"w-full"}
            >
              <TwTabContainer
                className=""
                tabsClassName="border-b px-5 md:px-10"
                // selectedTab={selectedTab}
                tabs={[
                  {
                    name: 'Flex Pass', key: 'classpass', onClick: () => { },
                    // icon: UserIcon,
                    tabPanelComponent: (
                      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 py-4">
                        {renderProducts(productsList, "classpass")}
                      </ul>
                    )
                  },
                  {
                    name: 'Subscription', key: 'subscription', onClick: () => { },
                    // icon: BuildingOfficeIcon,
                    tabPanelComponent: (
                      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 py-4">
                        {renderProducts(productsList, "subscription")}
                      </ul>
                    )
                  },

                ]}
              />
              {/* <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-300 ">
                <thead className="">
                  <tr className="text-center [bz-th-row]">
                    <th scope="col" className="py-3.5 pl-4 sm:pl-6 pr-3 text-center text-base font-extrabold text-gray-900 rounded-l-2xl">
                      PRODUCT NAME
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                      TYPE
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                      PRICE
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                      CREDITS INCLUDED
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                      BILLING CYCLE
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900 rounded-r-2xl"></th>
                  </tr>
                </thead>
                <tbody className="divide-y-8 !border-y-0 divide-white ">
                  {productsList.length ? productsList.map((row, i) => (
                    <tr key={i} className="bz-td-row">
                      <td className="whitespace-nowrap pl-4 sm:pl-6 pr-3 py-4 text-center text-base font-bold rounded-l-2xl truncate"><div>{row.productName}</div></td>
                      <td className="whitespace-nowrap px-3 py-4 text-center text-sm font-bold capitalize"><div>{row?.productType}</div></td>
                      <td className="whitespace-nowrap px-3 py-4 text-center text-sm font-bold"><div>€{row.price}</div></td>
                      <td className="whitespace-nowrap px-3 py-4 text-center text-sm font-bold">
                        <div>{row?.productType == "classpass" ? row?.productFields?.noOfAllowedSessions : "Unlimited"}</div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-center text-sm font-bold">
                        {row?.productType == "classpass" ? (<div className="flex flex-col justify-center items-center">
                          <span style={{ fontSize: 14, lineHeight: "14px" }}>One-time</span>
                          <p className="text-sm text-gray-300 max-w-24 text-wrap text-center">
                            Valid:&nbsp;
                            {(row?.productFields?.validUntilConsumed === true) ?
                              `Until Consumed`
                              :
                              `${parseInt(row?.productFields?.validityDays)} days from purchase date`}
                          </p>
                        </div>) : (<div className="flex flex-col justify-center items-center">
                          {billingPeriod.find((f) => f.data.interval == row?.productFields?.billingPeriod.interval && f.data.interval_count == row?.productFields?.billingPeriod.interval_count).title}

                        </div>)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-center text-sm rounded-r-2xl">
                        <div className="flex gap-2 justify-center items-center">
                          <TwButton
                            variant="brown-coffee"
                            className="!px-3 !py-2 text-sm"
                            onClick={() => {
                              bookProduct(row._id);
                            }}
                          >
                            Buy Now
                          </TwButton>
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan={5} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                        No Pass created
                      </td>
                    </tr>
                  )}

                </tbody>
              </table>
            </div> */}
              {/* <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {renderProducts(productsList)}
            </ul> */}
              {showViewMore ? (<div className={"flex flex-row justify-center my-4"}>
                <button
                  className={
                    "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                  }
                  onClick={() => {
                    setListPageNumber(listPageNumber + 1);
                  }}
                >
                  View More
                </button>
              </div>) : ""}
            </div>) : (loadingReduxState.sectionLoading !== undefined && loadingReduxState.sectionLoading === false) ? (
              <div className="flex flex-col justify-center items-center gap-5 text-center h-full">
                <img
                  className={"w-40 md:w-60"}
                  src={noEventImage}
                  alt={""}
                />
                <div className={"text-brown-coffee text-lg font-bold"}>
                  No products created
                </div>
              </div>
            ) : ""}

          </TwContainer>
        </div>} />
  );
}
